var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "6.87 4.87 11.93 15.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8428 13.2168C14.9737 13.2168 16.7012 11.4893 16.7012 9.35839C16.7012 7.22746 14.9737 5.5 12.8428 5.5C10.7118 5.5 8.98438 7.22746 8.98438 9.35839C8.98438 11.4893 10.7118 13.2168 12.8428 13.2168Z",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0684 12.6895C15.9484 12.8596 16.7414 13.3317 17.3104 14.0242C17.8793 14.7168 18.1886 15.5863 18.1848 16.4826V19.5871H7.5V16.4826C7.503 15.6018 7.80821 14.7486 8.36463 14.0658C8.92105 13.383 9.85198 12.8312 10.7141 12.6504",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4619ce53243f1d0f2a5da077ea7c689a.svg";
export { ForwardRef as ReactComponent };